import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './assets/styles/global.css';

import AppPesquisador from './AppPesquisador';
import AppAdmin from './AppAdmin';
import AppInstitucional from './AppInstitucional';
import { getStorage, removeStorage, setStorage } from './utils/storage';

import Login from './pages/Login';
import EsqueceuSenha from './pages/EsqueceuSenha';
import AdminDashboard from './pages/AdminDashboard';
import CadastroPesquisador from './pages/CadastroPesquisador';
import CadastroPaciente from './pages/CadastroPaciente';
import PesquisadorDashboard from './pages/PesquisadorDashboard';
import PerfilPaciente from './pages/PerfilPaciente';
import TestePaciente from './pages/TestePaciente';
import DiagnosticoPaciente from './pages/DiagnosticoPaciente';
import ModuloPaciente from './pages/ModuloPaciente';
import CadastroAdministrador from './pages/CadastroAdministrador';
import TesteRemoto from './pages/TesteRemoto';
import TesteRemotoIniciar from './pages/TesteRemotoIniciar';
import TesteAutomatico from './pages/TesteAutomatico';
import InstitucionalDashboard from './pages/InstitucionalDashboard';
import InstitucionalTestePaciente from './pages/InstitucionalTestePaciente';
import InstitucionalModuloPaciente from './pages/InstitucionalModuloPaciente';
import InstitucionalDiagnosticoPaciente from './pages/InstitucionalDiagnosticoPaciente';
import InstitucionalPacientesPesquisador from './pages/InstitucionalPacientesPesquisador';
import InstitucionalTestesPaciente from './pages/InstitucionalTestesPaciente';
import NotFound from './pages/NotFound';

(function captureTokenFromUrl() {
  try {
    const search = window.location.search;
    if (!search) return;
    const params = new URLSearchParams(search);
    const tokenFromUrl = params.get('token');
    const tipoFromUrl = params.get('tipo');

    if (tokenFromUrl && tipoFromUrl) {
      setStorage('token', tokenFromUrl);
      setStorage('tipo', tipoFromUrl);

      if (tipoFromUrl === '1') {
        setStorage('isMemnon', true);
      } else {
        removeStorage('isMemnon');
      }

      const url =
        tipoFromUrl === '1'
          ? `${process.env.PUBLIC_URL}/institucional/dashboard`
          : `${process.env.PUBLIC_URL}/pesquisador/dashboard`;

      setTimeout(() => {
        window.history.replaceState({}, document.title, url);
      }, 500);
    }
  } catch (error) {
    console.error('Error capturing token from URL:', error);
  }
})();

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route exact path={`${process.env.PUBLIC_URL}/`}>
        <Login />
      </Route>
      <Route exact path={`${process.env.PUBLIC_URL}/restrito`}>
        <Login error="Você não tem permissão para acessar essa página. Faça login e tente novamente." />
      </Route>
      <Route exact path={`${process.env.PUBLIC_URL}/esqueceu-senha`}>
        <EsqueceuSenha />
      </Route>

      <Route
        exact
        path={[
          `${process.env.PUBLIC_URL}/admin/dashboard`,
          `${process.env.PUBLIC_URL}/admin/cadastrar-pesquisador`,
          `${process.env.PUBLIC_URL}/admin/editar-pesquisador/:id`,
          `${process.env.PUBLIC_URL}/admin/list-administradores`,
          `${process.env.PUBLIC_URL}/admin/cadastrar-administrador`,
          `${process.env.PUBLIC_URL}/admin/editar-administrador/:id`,
        ]}
      >
        <AppAdmin>
          <Route exact path={`${process.env.PUBLIC_URL}/admin/dashboard`}>
            <AdminDashboard />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/admin/cadastrar-pesquisador`}
          >
            <CadastroPesquisador />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/admin/editar-pesquisador/:id`}
          >
            <CadastroPesquisador />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/admin/list-administradores`}
          >
            <AdminDashboard admin={true} />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/admin/cadastrar-administrador`}
          >
            <CadastroAdministrador />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/admin/editar-administrador/:id`}
          >
            <CadastroAdministrador />
          </Route>
        </AppAdmin>
      </Route>

      <Route
        exact
        path={[
          `${process.env.PUBLIC_URL}/pesquisador/dashboard`,
          `${process.env.PUBLIC_URL}/pesquisador/cadastrar-paciente`,
          `${process.env.PUBLIC_URL}/pesquisador/perfil-paciente/:id`,
          `${process.env.PUBLIC_URL}/pesquisador/editar-paciente/:id`,
          `${process.env.PUBLIC_URL}/pesquisador/teste/:id/modulos`,
          `${process.env.PUBLIC_URL}/pesquisador/teste/:id/modulo/:module_number`,
          `${process.env.PUBLIC_URL}/pesquisador/teste/:id/diagnostico`,
          `${process.env.PUBLIC_URL}/pesquisador/novo-teste/:id/modulo/:module_number`,
        ]}
      >
        <AppPesquisador>
          <Route exact path={`${process.env.PUBLIC_URL}/pesquisador/dashboard`}>
            <PesquisadorDashboard />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/pesquisador/cadastrar-paciente`}
          >
            <CadastroPaciente />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/pesquisador/perfil-paciente/:id`}
          >
            <PerfilPaciente />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/pesquisador/editar-paciente/:id`}
          >
            <CadastroPaciente />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/pesquisador/teste/:id/modulos`}
          >
            <TestePaciente />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/pesquisador/teste/:id/modulo/:module_number`}
            component={ModuloPaciente}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/pesquisador/teste/:id/diagnostico`}
          >
            <DiagnosticoPaciente />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/pesquisador/novo-teste/:id/modulo/:module_number`}
            component={TesteAutomatico}
          />
        </AppPesquisador>
      </Route>

      <Route exact path={`${process.env.PUBLIC_URL}/teste-remoto/:remote_code`}>
        <TesteRemoto />
      </Route>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/teste-remoto/:remote_code/iniciar/:module_number`}
      >
        <TesteRemotoIniciar />
      </Route>

      {/* Rotas para usuários institucionais (can_see = institucional) */}
      <Route
        exact
        path={[
          `${process.env.PUBLIC_URL}/institucional/dashboard`,
          `${process.env.PUBLIC_URL}/institucional/cadastrar-pesquisador`,
          `${process.env.PUBLIC_URL}/institucional/editar-pesquisador/:id`,
          `${process.env.PUBLIC_URL}/institucional/pesquisador/:id_pesquisador/paciente/:id_paciente/teste/:id_teste/modulos`,
          `${process.env.PUBLIC_URL}/institucional/pesquisador/:id_pesquisador/paciente/:id_paciente/teste/:id_teste/modulo/:module_number`,
          `${process.env.PUBLIC_URL}/institucional/pesquisador/:id_pesquisador/paciente/:id_paciente/teste/:id_teste/diagnostico`,
          `${process.env.PUBLIC_URL}/institucional/pesquisador/:id_pesquisador/pacientes`,
          `${process.env.PUBLIC_URL}/institucional/pesquisador/:id_pesquisador/paciente/:id_paciente/testes`,
        ]}
      >
        <AppInstitucional>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/institucional/dashboard`}
          >
            <InstitucionalDashboard />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/institucional/cadastrar-pesquisador`}
          >
            <CadastroPesquisador />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/institucional/editar-pesquisador/:id`}
          >
            <CadastroPesquisador />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/institucional/pesquisador/:id_pesquisador/paciente/:id_paciente/teste/:id_teste/modulos`}
          >
            <InstitucionalTestePaciente />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/institucional/pesquisador/:id_pesquisador/paciente/:id_paciente/teste/:id_teste/modulo/:module_number`}
            component={InstitucionalModuloPaciente}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/institucional/pesquisador/:id_pesquisador/paciente/:id_paciente/teste/:id_teste/diagnostico`}
          >
            <InstitucionalDiagnosticoPaciente />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/institucional/pesquisador/:id_pesquisador/pacientes`}
          >
            <InstitucionalPacientesPesquisador />
          </Route>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/institucional/pesquisador/:id_pesquisador/paciente/:id_paciente/testes`}
          >
            <InstitucionalTestesPaciente />
          </Route>
        </AppInstitucional>
      </Route>

      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  </BrowserRouter>,
  document.getElementById('root'),
);
